<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-show-modal-input-buzzer-number"
      data-bs-toggle="modal"
      data-bs-target="#modalInputBuzzerNumber"
    ></button>
    <button
      style="display: none"
      type="button"
      class="btn-hide-modal-input-buzzer-number"
      data-bs-dismiss="modal"
      data-bs-target="#modalInputBuzzerNumber"
    ></button>
    <div
      class="modal fade"
      id="modalInputBuzzerNumber"
      tabindex="-1"
      aria-labelledby="modalInputBuzzerNumberLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <KskModalShell :width="480" :show-close="false">
        <div class="ksk-buzzer">
          <div class="ksk-buzzer__icon">
            <span class="material-icons-round">notifications_active</span>
          </div>
          <h2 id="modalInputBuzzerNumberLabel" class="ksk-buzzer__title">
            {{ buzzerNumberText || $t("kiosk.buzzer.title") }}
          </h2>
          <p class="ksk-buzzer__caption">{{ $t("kiosk.buzzer.caption") }}</p>

          <div class="ksk-buzzer__digits">
            <div
              v-for="slot in 2"
              :key="slot"
              class="ksk-buzzer__digit"
              :class="{ 'ksk-buzzer__digit--active': input.length === slot - 1 }"
            >
              <span>{{ input[slot - 1] || "" }}</span>
              <span v-if="input.length === slot - 1" class="ksk-buzzer__caret"></span>
            </div>
          </div>

          <KskNumericKeypad class="ksk-buzzer__keypad" clear-token="C" back-token="X" @press="handleKeyClick" />

          <!-- KSK028: keeps the btn-close-modal class — PaymentSelection closes
               modals with a page-wide $(".btn-close-modal").click(). -->
          <KskButton
            class="btn-close-modal ksk-buzzer__submit"
            size="md"
            block
            icon-right="arrow_forward"
            :disabled="input.length < 2"
            @click="inputBuzzerNumber(input)"
          >{{ $t("kiosk.common.continue") }}</KskButton>
        </div>
      </KskModalShell>
    </div>
  </div>
</template>

<script>
import KskNumericKeypad from "./ui/KskNumericKeypad.vue";
import KskButton from "./ui/KskButton.vue";
import KskModalShell from "./ui/KskModalShell.vue";

export default {
  name: "ModalInputBuzzerNumber",
  components: {
    KskNumericKeypad,
    KskButton,
    KskModalShell,
  },
  props: {
    keyReload: {
      required: true,
    },
    inputBuzzerNumber: {
      type: Function,
      default: () => { },
    },
    buzzerNumberText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      merchantCode: "",
      branchCode: "",
      input: "",
    };
  },
  mounted() {
    this.merchantCode = this.$store.state.merchantCode;
    this.branchCode = this.$store.state.branchCode;
  },
  methods: {
    handleKeyClick(key) {
      if (key === "C") {
        this.input = "";
      } else if (key === "X") {
        this.input = this.input.slice(0, -1);
      } else {
        if (this.input.length < 2) {
          this.input += key;
        }
      }
    },
    watch: {
      keyReload() {
        this.input = '';
      }
    }
  },
};
</script>

<style scoped>
/* Compact: a 2-digit entry only needs a small dialog (480px, 28px padding,
   24px title, 64px keys, 60px button). */
.modal :deep(.ksk-modal) {
  padding: 28px;
  border-radius: 28px;
}
.ksk-buzzer {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: var(--ksk-font);
  color: var(--ksk-text);
  text-align: center;
}
.ksk-buzzer__icon {
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--ksk-primary-container);
  color: var(--ksk-primary);
}
.ksk-buzzer__icon .material-icons-round {
  font-size: 28px;
}
.ksk-buzzer__title {
  margin: 12px 0 0;
  font-family: var(--ksk-font);
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ksk-text);
}
.ksk-buzzer__caption {
  margin: 4px 0 0;
  font-size: 16px;
  line-height: 22px;
  color: var(--ksk-text-secondary);
}

.ksk-buzzer__digits {
  display: flex;
  gap: 12px;
  margin: var(--ksk-space-2) 0;
}
.ksk-buzzer__digit {
  position: relative;
  width: 80px;
  height: 92px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* KSK063: digit boxes as muted tiles, outlined only when active. */
  border: 2px solid transparent;
  border-radius: 18px;
  background: var(--ksk-surface-muted);
  font-size: 44px;
  line-height: 52px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--ksk-text);
}
.ksk-buzzer__digit--active {
  border-color: var(--ksk-primary);
  background: var(--ksk-surface);
}
.ksk-buzzer__caret {
  width: 3px;
  height: 40px;
  border-radius: 2px;
  background: var(--ksk-primary);
  animation: ksk-buzzer-blink 1s steps(1) infinite;
}
@keyframes ksk-buzzer-blink {
  50% {
    opacity: 0;
  }
}

.ksk-buzzer__keypad {
  width: 100%;
  min-width: 0;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 64px;
  gap: 10px;
}
.ksk-buzzer__keypad :deep(.ksk-keypad__key) {
  border-radius: 14px;
  font-size: 30px;
  line-height: 36px;
}
.ksk-buzzer__keypad :deep(.ksk-keypad__key .material-icons-round) {
  font-size: 28px;
}
.ksk-buzzer__keypad :deep(.ksk-keypad__clear) {
  font-size: 18px;
}
.ksk-buzzer__submit {
  height: 60px;
  margin-top: var(--ksk-space-2);
  font-size: 20px;
}
</style>
